export default __webpack_public_path__ + "static/media/threedots.9505fd76.svg";